import { t } from '../../i18next';
import { postRequest } from '../../shared/utils';
import { compareEditedRowObjects } from '../../shared/utils/commitHandlerHelper';

export const CommitHandler = async (props) => {
  const timestamp = new Date().toISOString().substring(0, 19);
  const {
    allAccessibleColumns,
    editedRow,
    userDetails,
    editedRowOriginal,
    configSchema,
    tableDetails,
  } = props;
  const allAsyncResults: any = { success: true, data: [], errors: [] };
  const mutationTables = await getMutationTable(allAccessibleColumns);
  const [viewId, muttationId] =
    mutationTables.mbd_screen_grid_attribute_config[0].mutationTablePkey.split(':');

  const generateUpdateRow = (rowData, originalData) => {
    const updatedData = compareEditedRowObjects(
      { ...rowData, attribute_config_id: rowData.attribute_config_id },
      originalData,
      'attribute_config_id',
    );
    return {
      ...updatedData,
      updated_by: userDetails?.userId,
      update_date: timestamp,
    };
  };

  const prepareRowData = (reqDataSet) => {
    const { rowData } = reqDataSet;
    const { default_value: defaultValue, attr_duplicate_config: attrDuplicateConfig } = rowData;
    if (attrDuplicateConfig) {
      rowData['attr_duplicate_config'] = attrDuplicateConfig;
    } else if (defaultValue) {
      rowData['attr_duplicate_config'] = defaultValue;
    } else {
      rowData['attr_duplicate_config'] = null;
    }
    delete rowData.default_value;
  };

  if (editedRow?.length) {
    try {
      const updatedRows = rowHandler(mutationTables, editedRow);
      const attrConfigUpdate = updatedRows.map((item) => {
        prepareRowData(item);
        const obj = generateUpdateRow(item.rowData, editedRowOriginal);
        const where = {};
        where[muttationId] = { _eq: item.rowData[viewId] };
        return {
          where,
          _set: obj,
        };
      });
      const tableName = mutationTables.mbd_screen_grid_attribute_config[0].mutationTableName;
      const result = await postRequest('/api/tables', {
        screenGridId: tableDetails.id,
        tables: [
          {
            pkey: muttationId,
            schema: configSchema,
            table: tableName,
            updateObjects: attrConfigUpdate,
            deleteIds: [],
            insertObjects: [],
          },
        ],
      });

      if (result.errors) {
        allAsyncResults.errors.push({
          message: t('error.action_failed_following', {
            htz: 'data',
            msg: result.errors[0]?.message,
          }),
        });
        allAsyncResults.success = false;
      }
      return allAsyncResults;
    } catch (error) {
      return { success: false, error: [{ message: error?.message }] };
    }
  }
};

const getMutationTable = (allAccessibleColumns) => {
  return allAccessibleColumns.reduce((resp, item) => {
    const { mutationTableName } = item;
    if (!mutationTableName) {
      return resp;
    }
    if (!resp?.[mutationTableName]) {
      resp[mutationTableName] = [];
    }
    resp[mutationTableName].push(item);
    return resp;
  }, {});
};

const rowHandler = (mutationTables, rowDetails) => {
  const reqData = rowDetails.reduce((data, item) => {
    const groupRecord = {};
    groupRecord['rowData'] = item;
    for (const key in mutationTables) {
      groupRecord[key] = mutationTables[key].reduce((resp, record) => {
        const { mutationColumnName, attrInternalName } = record;
        resp[mutationColumnName ?? attrInternalName] = item[attrInternalName];
        return resp;
      }, {});
    }
    data.push(groupRecord);
    return data;
  }, []);
  return reqData;
};
